export enum ReceiptModal {
  DIVCAPGAINS = 'divcapgains-modal',
  SETTLEMENTFUND = 'settlementfund-modal',
  BENEFICIARIES = 'beneficiaries-modal',
}
